var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotPinnedIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4444 15.4667H19.8167L18.8611 9.06667H19.3333C19.4807 9.06667 19.622 9.01048 19.7262 8.91046C19.8304 8.81044 19.8889 8.67478 19.8889 8.53333C19.8889 8.39188 19.8304 8.25623 19.7262 8.15621C19.622 8.05619 19.4807 8 19.3333 8H12.6667C12.5193 8 12.378 8.05619 12.2738 8.15621C12.1696 8.25623 12.1111 8.39188 12.1111 8.53333C12.1111 8.67478 12.1696 8.81044 12.2738 8.91046C12.378 9.01048 12.5193 9.06667 12.6667 9.06667H13.1389L12.1833 15.4667H11.5556C11.4082 15.4667 11.2669 15.5229 11.1627 15.6229C11.0585 15.7229 11 15.8586 11 16C11 16.1414 11.0585 16.2771 11.1627 16.3771C11.2669 16.4771 11.4082 16.5333 11.5556 16.5333H15.4444V23.4667C15.4444 23.6081 15.503 23.7438 15.6072 23.8438C15.7114 23.9438 15.8527 24 16 24C16.1473 24 16.2887 23.9438 16.3928 23.8438C16.497 23.7438 16.5556 23.6081 16.5556 23.4667V16.5333H20.4444C20.5918 16.5333 20.7331 16.4771 20.8373 16.3771C20.9415 16.2771 21 16.1414 21 16C21 15.8586 20.9415 15.7229 20.8373 15.6229C20.7331 15.5229 20.5918 15.4667 20.4444 15.4667V15.4667ZM13.3056 15.4667L14.2611 9.06667H17.7389L18.6944 15.4667H13.3056Z",
    fill: "#3030AD",
    stroke: "#3030AD",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 1.5,
    stroke: "#3030AD",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotPinnedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notPinnedIcon.41e1ad290286f0df30d3ad470ea0817f.svg";